export default __webpack_public_path__ + "static/media/Resume.f3b1defc.pdf";